import React, { useState } from "react";
import { useTab } from "../../../contexts/tab";
import classNames from "classnames";
import { deleteIcon, editIcon } from "../../icon";
import PaperSizeForm from "../forms/PaperSizeForm";
import DeletePaperSizeModal from "../forms/DeletePaperSize";
import ShimmerTable from "../../shimmer/ShimmerTable";
import { useAuth } from "../../../contexts/auth";
import { useFormik } from "formik";
import { basePath } from "../../config";
import { toast } from "react-toastify";

export default function TabBodyPaperSize() {
  const [{ tabData }, { setTabData }] = useTab();
  const [isOpen, setIsOpen] = useState(false);
  const [paperSizeToEdit, setPaperSizeToEdit] = useState(null);
  const [paperSizeToDelete, setPaperSizeToDelete] = useState(null);
  const [{ activeUser }] = useAuth();

  function handaleEdit(label) {
    const [width, height] = label?.size?.split("X") || [];
    setPaperSizeToEdit({ ...label, width, height });
    setIsOpen(true);
  }

  async function submitFormData(values) {
    try {
      const res = await fetch(basePath + "getFilteredPaperSize", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${activeUser?.remember_token}`,
        },
        body: JSON.stringify(values),
      });
      const data = await res.json();

      if (res.status === 401) {
        toast.error(data.message);
        document.cookie =
          "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }

      if (data.status) {
        setTabData({ data: JSON.parse(data.data), links: [] });
      } else {
        setTabData(null);
      }
    } catch (error) {
      setTabData(null);
      console.error("TabProvider:: api calling fail =>", error);
    }
  }

  const formik = useFormik({
    initialValues: {
      paper_size: "",
    },
    onSubmit: (values, actions) => {
      submitFormData(values, actions, activeUser);
    },
  });

  async function handleReset() {
    formik.resetForm({
      paper_size: "",
    });

    setTabData(null);
    const restApi = "getPaperSizes";

    try {
      const res = await fetch(basePath + restApi, {
        method: "post",
        headers: {
          Authorization: `Bearer ${activeUser?.remember_token}`,
          Accept: "application/json",
        },
      });

      const data = await res.json();

      if (res.status === 401) {
        toast.error(data.message);
        document.cookie =
          "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }

      if (data.status) {
        setTabData(JSON.parse(data.data));
      } else {
        setTabData(null);
      }
    } catch (error) {
      setTabData(null);
      console.error("TabProvider:: api calling fail =>", error);
    }
  }

  return (
    <div>
      <div className="flex justify-between bg-slate-200 mb-4 items-center p-2 rounded-md">
        <form
          className="flex gap-3 items-center"
          onSubmit={formik.handleSubmit}
        >
          <label>
            <span className="mr-3">Search:</span>
            <input
              className="rounded-sm py-1 px-2"
              value={formik.values.paper_size}
              onChange={formik.handleChange}
              type="text"
              name="paper_size"
              placeholder="Search Paper size"
            />
          </label>

          <button className="bg-white rounded-sm px-2 py-1" type="submit">
            Submit
          </button>
          <button
            onClick={handleReset}
            className="bg-white rounded-sm px-2 py-1"
            type="button"
          >
            Reset
          </button>
        </form>
        {activeUser?.user_permission <= 2 && (
          <button
            onClick={() => setIsOpen(true)}
            className="bg-orange text-white p-2 rounded-md"
          >
            Add Paper Size
          </button>
        )}
      </div>

      <PaperSizeForm
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        paperSizeToEdit={paperSizeToEdit}
        setPaperSizeToEdit={setPaperSizeToEdit}
      />
      <DeletePaperSizeModal
        setPaperSizeToDelete={setPaperSizeToDelete}
        paperSizeToDelete={paperSizeToDelete}
      />

      {!tabData && <ShimmerTable />}
      {tabData && (
        <table className="dataTable">
          <thead>
            <tr>
              <th scope="col">No</th>
              <th scope="col">Paper Size</th>
              <th scope="col">Note</th>
              {activeUser?.user_permission <= 2 && <th scope="col">Action</th>}
            </tr>
          </thead>
          <tbody>
            {tabData &&
              tabData.data.map(({ id, paper_size, note }, i) => {
                return (
                  <tr key={id}>
                    <td scope="col">{i + (tabData.from + 0)}</td>
                    <td scope="col">{paper_size}</td>
                    <td scope="col">{note}</td>
                    {activeUser?.user_permission <= 2 && (
                      <td scope="col">
                        <button
                          className="bg-green-600 p-2 rounded-md my-1"
                          onClick={() => handaleEdit({ id, paper_size, note })}
                        >
                          {editIcon}
                        </button>
                        <button
                          className={classNames(
                            "p-2 rounded-md ml-2 bg-orange"
                          )}
                          onClick={() =>
                            setPaperSizeToDelete({ id, paper_size })
                          }
                        >
                          {deleteIcon}
                        </button>
                      </td>
                    )}
                  </tr>
                );
              })}
          </tbody>
        </table>
      )}
    </div>
  );
}
